import React from 'react';

import { IonButton } from '@ionic/react';

const Button = (props: any) => {
  return <IonButton data-cy={'Button'} {...props} />;
};

export default Button;
